import { render, staticRenderFns } from "./review-link.vue?vue&type=template&id=44261252"
import script from "./review-link.vue?vue&type=script&lang=js"
export * from "./review-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports